import { useState } from 'react';
import LeaseService from '../../../../../services/leaseService';
import { toastr } from 'react-redux-toastr';

export function useUpdateReceivesHousingAssistance(
  organizationId: string,
  propertyId: string,
  leaseId: string,
) {
  const [isLoading, setIsLoading] = useState(false);

  const updateReceivesHousingAssistance = async (value: boolean | null) => {
    const service = new LeaseService();

    setIsLoading(true);

    try {
      await service.updateReceivesHousingAssistance(
        organizationId,
        propertyId,
        leaseId,
        value,
      );

      toastr.success('Success', 'Receives Housing Assistance was updated.');
    } catch (error) {
      toastr.error('Error', error.toString());
    }

    setIsLoading(false);
  };

  return [updateReceivesHousingAssistance, isLoading];
}
